import React from 'react';
import { useDashboard } from '../../context/DashboardContext';
import { useI18n } from '../../i18n';

import { ReactComponent as FeedIcon } from '../../assets/icons/feed.svg';
import { ReactComponent as ProjectsIcon } from '../../assets/icons/projects.svg';
import { ReactComponent as TeamsIcon } from '../../assets/icons/teams.svg';
import { ReactComponent as FileSyncIcon } from '../../assets/icons/filesync.svg';
import { ReactComponent as NotesIcon } from '../../assets/icons/notes.svg';
import { ReactComponent as EmailIcon } from '../../assets/icons/email.svg';
import { ReactComponent as CalendarIcon } from '../../assets/icons/calender.svg';
import { ReactComponent as MeetingIcon } from '../../assets/icons/meeting.svg';
import { ReactComponent as SocialMediaIcon } from '../../assets/icons/social_media.svg';
import { ReactComponent as AttendanceIcon } from '../../assets/icons/attendance.svg';

const IconMenu = ({ onSectionClick }) => {
  const { t } = useI18n();
  const { activeView } = useDashboard();

  const menuItems = [
    { id: 'email', Icon: EmailIcon, label: t('navigation.email') },
    { id: 'projects', Icon: ProjectsIcon, label: t('navigation.projects') },
    { id: 'teams', Icon: TeamsIcon, label: t('navigation.teams') },
    { id: 'meeting', Icon: MeetingIcon, label: t('navigation.meeting') },
    { id: 'calendar', Icon: CalendarIcon, label: t('navigation.calendar') },
    { id: 'filesync', Icon: FileSyncIcon, label: t('navigation.file_sync') },
    { id: 'notes', Icon: NotesIcon, label: t('navigation.notes') },
    { id: 'feed', Icon: FeedIcon, label: t('navigation.news_feed') },
    { id: 'social_media', Icon: SocialMediaIcon, label: t('navigation.social_media'), isLink: true, href: '#' },
    { id: 'attendance', Icon: AttendanceIcon, label: t('navigation.attendance'), isLink: true, href: '#' },
  ];

  const handleClick = (sectionId) => {
    if (onSectionClick) {
      onSectionClick(sectionId);
    }
  };

  return (
    <div className="icon-menu">
      {menuItems.map((item) => (
        <div
          key={item.id}
          className={`icon-menu-item ${activeView === item.id ? 'active' : ''}`}
          onClick={() => item.isLink ? window.location.href = item.href : handleClick(item.id)}
          style={{ cursor: 'pointer' }}
        >
          <item.Icon className="icon-menu-img" aria-hidden="true" focusable="false" />
          <span className="icon-label">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default IconMenu;
